import type { AutreLienVu } from '../partage/api/types';
import { MOTS_DES_SORTES_A_LIER, S_APPUIE_SUR } from '../partage/vocabulaire';

/**
 * Le bloc « Liens » de la fiche Plan, sans rendu (chantier liens-entre-bulles, ticket 05,
 * décision 13 du cadrage ; spec du chantier, « La fiche » et « Les mots ») : les liens qui ne sont
 * pas des conditions, tels que le serveur les rend avec leur sens vu de la bulle (`autresLiens`),
 * rangés par ce qu'ils disent d'elle. Rien ne se calcule ici sur le moteur.
 */

/** Ce qu'un lien dit de la bulle de la fiche. */
export type CoteDuLien = 'sert_a' | 's_appuie_sur' | 'touche_a';

/** L'ordre des groupes du bloc : ce qu'elle sert, ce sur quoi elle s'appuie, ce à quoi elle touche. */
const ORDRE: readonly CoteDuLien[] = ['sert_a', 's_appuie_sur', 'touche_a'];

const TITRES: Record<CoteDuLien, string> = {
  sert_a: MOTS_DES_SORTES_A_LIER.sert_a,
  s_appuie_sur: S_APPUIE_SUR,
  touche_a: MOTS_DES_SORTES_A_LIER.touche_a,
};

export interface GroupeDeLiens {
  cote: CoteDuLien;
  titre: string;
  liens: AutreLienVu[];
}

/** « Sert à » sortant : elle sert à l'autre ; entrant : elle s'appuie sur l'autre. */
export function coteDuLien(lien: Pick<AutreLienVu, 'sorte' | 'sens'>): CoteDuLien {
  if (lien.sorte === 'touche_a') return 'touche_a';
  return lien.sens === 'entrant' ? 's_appuie_sur' : 'sert_a';
}

/** Les groupes non vides, dans l'ordre ; chacun garde l'ordre reçu, cachés compris. */
export function lignesDesLiens(liens: readonly AutreLienVu[]): GroupeDeLiens[] {
  return ORDRE.map((cote) => ({ cote, titre: TITRES[cote], liens: liens.filter((l) => coteDuLien(l) === cote) })).filter(
    (g) => g.liens.length > 0
  );
}

/** Le projet de l'autre bulle, nommé seulement s'il n'est pas celui de la fiche. */
export function projetDuLien(lien: Pick<AutreLienVu, 'autreProjet' | 'projet'>): string | null {
  return lien.autreProjet && lien.projet ? lien.projet.titre : null;
}
